import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_GET_DASH_RECENT_ACTIVATION_LIST = (take?: number) => ['getDashRecentActivationList', take].filter(Boolean)

export const getDashRecentActivationList = async (take: number): Promise<IPortalUnitSearchModel[]> =>
  axios.get(`/dashwidget/getrecentactivationunitlist?take=${take}`).then((res) => res.data?.data)

type QueryFnType = typeof getDashRecentActivationList

type Props = {
  config?: QueryConfig<QueryFnType>
  take: number
}

export const useGetDashRecentActivationList = ({ config, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: QUERY_KEY_GET_DASH_RECENT_ACTIVATION_LIST(take),
    queryFn: () => getDashRecentActivationList(take)
  })
